module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av116-6bf733538449748bea68ba5d234471b3.jpg";